module.exports = __webpack_public_path__ + "img/scholar.c6b834c3.svg";